import { create } from "zustand";

interface TableOrderStore {
  activeTable: string | null;
  activeBill: string;

  selectTable: (table: string) => void;
  selectBill: (bill: string) => void;
  clearSelection: () => void;
}

export const useTableOrderStore = create<TableOrderStore>()((set) => ({
  activeTable: null,
  activeBill: "bill_1",

  selectTable: (table: string) =>
    set({ activeTable: table, activeBill: "bill_1" }),

  selectBill: (bill: string) => set({ activeBill: bill }),

  clearSelection: () => set({ activeTable: null, activeBill: "bill_1" }),
}));
